module.exports = __webpack_public_path__ + "static/CircularPro-Medium.03178f59.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-Medium.woff
// module id = 731
// module chunks = 168707334958949